module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageCurrency.svg?7c67e3ff";